import { Component } from '@angular/core';

@Component({
  selector: 'jhi-my-bills',
  templateUrl: './my-bills.component.html',
})
export class MyBillsComponent {
  steps: Array<{ title: string; url: string; idCypress: string }>;
  active = 1;

  constructor() {
    this.steps = [
      { title: 'bills.title', url: '/user/my-bills/bills', idCypress: 'bills' },
      { title: 'refund.title', url: '/user/my-bills/refunds', idCypress: 'refunds' },
    ];
  }
}
